<template>
  <section class="section section_bg first_page" >
    <loading-block v-if="is_load==false" :loading="!is_load"/>

    <div class=" " v-if="is_load" >
      <div class="d-flex justify-content-center">
      <div class="section_header container back_div_element no_margin  mb-2 mt-2   " v-if="is_load==true">
        <router-link tag="a" class="btn" :to="{name: 'services'}"  ><i class="fa fa-backward"></i> Назад</router-link>

      </div>
      </div>


      <div class="second_section container d-flex justify-content-center  section_gray_bg ">




        <div class="  row row-grid align-items-center"           >
          <div class="col-12 img_div d-flex justify-content-center">
            <v-lazy-image  :src="image_url+service.image" class="p-4 img-fluid floating"/>
          </div>
          <div class="col-12 p-4">
            <h2 class="text-center">{{ service.name }}</h2>
            <div class="pr-md-5" >
              <editorjsrender v-if="service.content_json && service.content_json.blocks" :align_style="'center'"   :blocks_json="service.content_json.blocks" ></editorjsrender>

            </div>
          </div>
        </div>
      </div>
    </div>

   <div class="container d-flex justify-content-center  second_section" v-if="is_load && reviews.length>0">

     <div class="col-12" v-if="is_load && reviews.length>0">
       <ReviewWidget :reviews="reviews"/>


    </div></div>
    <section class="second_section container mt-2 mb-2  my-0 overflow-hidden " v-if="is_load">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container second_section pt-lg pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-10">
            <h4 class="display-4 ">Схема работы</h4>
            <p class="lead ">Следуйте простым шагам и вы достигните результата</p>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="row  mt-5">
          <div class="col-12 col-md-6 col-lg-6">
            <ol v-if="service.skip_search_developer==false">
              <li>Разместите задание</li>
              <li>Подождите пока исполнители оценят задание</li>
              <li>Выберите исполнителя</li>
              <li>Ждите результата</li>
            </ol>
            <ol v-if="service.skip_search_developer==true">
              <li>Разместите задание</li>
              <li>Оплатите счет</li>
              <li>Ждите результата</li>
            </ol>
          </div>
          <div class="col-12 col-md-6 col-lg-6">
            <card class="section_gray_bg"  shadow body-classes="p-lg-5">
              <h4 class="mb-1">Готовы к продуктивной работе?</h4>


              <div class="row">

                <router-link tag="a" class="ml-3 btn btn-sm"  :to="{name: 'service_new_request',params:{id:service.last_id}}">
                  Разместить<br> задание <i class="fa fa-plus-circle"></i>
                </router-link>



              </div>


            </card>
          </div>



        </div>
      </div>
    </section>
    <section class="section container    " v-if="is_load && works && works.length>0">
      <div class="col-12 justify-content-center">
        <h4 class="display-3 text-megablue text-center">Портфолио</h4>
      </div>
      <card class="portfolio_list tags_list_block ">
        <div class="row d-flex justify-content-center col-md-12 mt-3">
          <p><a   class="btn  ml-2 mr-2" :data-tag="all_works_tag" :title="'/service/'+service.alias+'/all_works_tag'"  :class="{ 'tag_not_active': !(current_portfolio_tag && current_portfolio_tag=='all_works_tag'),'tag_active': (current_portfolio_tag && current_portfolio_tag=='all_works_tag') }"     @click="openPortfolioTag('all_works_tag')">
            все работы
          </a></p>
          <p v-if="tags.length>0" :data-tag="tag" v-for="(tag,tag_key) in tags" :key="tag_key"  class="">

            <a   class="btn ml-2 mr-2" :title="'/service/'+service.alias+'/'+tag.tag" :class="{ 'tag_not_active': !(tag.tag && current_portfolio_tag && current_portfolio_tag==tag.tag),'tag_active': (tag.tag && current_portfolio_tag && current_portfolio_tag==tag.tag) }"     @click="openPortfolioTag(tag.tag)">

              {{ tag.title}}
              </a>&nbsp;&nbsp;
            </p>
          </div>
        </card>


        <div class="row justify-content-center">





          <div class="card col-12 col-sm-3 portfolio_block_work m-3 section_gray_bg"   v-if="(current_portfolio_tag && work.tags && work.tags.tags && work.tags.tags.includes(current_portfolio_tag)) || current_portfolio_tag=='all_works_tag'"  v-for="(work,work_index) in works" :key="work_index">
            <router-link  tag="a" class="mt-2"
                          :to="{name: 'user_page_one_portfolio', params: { user_id: work.user.last_id,work_id:work.last_id }}"><v-lazy-image class="card-img-top" :src="work.image" alt="Card image cap"/></router-link>
            <div class="card-body">
              <h5 class="card-title"><router-link  tag="a"
                                                                   :to="{name: 'user_page_one_portfolio', params: { user_id: work.user.last_id,work_id:work.last_id }}">{{ work.name}}</router-link></h5>
              <p class="card-text"><router-link  tag="a"
                                                                   :to="{name: 'works_in_category', params: { category_id: work.category_id,work_id:work.last_id }}">{{ work.category.name }}</router-link></p>
              <p class="card-text"> </p>
              <div class="d-flex align-items-center">
                <v-lazy-image :src="image_url+work.user.avatar" alt="Avatar" class="rounded-circle mr-2" style="width:50px; height:50px;"/>
                <p class="card-text mb-0"><router-link  tag="a"
                                                        :to="{name: 'developer', params: { username: work.user.username }}">{{ work.user.name}}</router-link></p>
              </div>
            </div>
          </div>







        </div>


      </section>


    </section>
  </template>

  <script>

  import Api from "../../models/Api";
  import Vue from "vue";
  import {eventBus} from "../../main";
  import CyrillicToTranslit from 'cyrillic-to-translit-js';
  import LoadingBlock from "@/components/Custom/LoadingBlock";
  import Editorjsrender from "@/models/Editorjsrender.vue";
  import VLazyImage from "v-lazy-image/v2";
  import ReviewWidget from "@/components/widgets/ReviewWidget";




  var Avatar = require('vue-avatar');


  export default {
    name: 'home',

    components: {VLazyImage,ReviewWidget,LoadingBlock,'editorjsrender': Editorjsrender},
    data() {
      return {
        "service":null,
        "works":[],
        "is_load":false,
        "image_url":null,
        "reviews":null,
        "current_portfolio_tag":null,
        'tags':[],
        'new_tag':[],

      }
    },
    mounted() {
      var service_id=this.$route.params.service_id;
      var request_tag=this.$route.params.tag;

      var app=this;


      Api.loadAboutService(service_id,function(data){
        app.image_url = Vue.config.IMAGE_URL;
        app.service=data.service;
        app.reviews=data.reviews;

        var tags=data.tags;
        if(tags.length>0){
          var i=0;


          var works=data.works;
          var tags=data.tags;
          const cyrillicToTranslit = new CyrillicToTranslit();
          works.forEach((element,index_el)=>{

            element.tags.tags.forEach((element_tag,index_tag)=>{
              element_tag="tag_"+cyrillicToTranslit.transform(element_tag, "_");
              element['tags']['tags'][index_tag]=element_tag;
            });
            works[index_el]=element;
          })
          tags.forEach((element,index) => {

             element.tag="tag_"+cyrillicToTranslit.transform(element.tag, "_")

              tags[index]=element;
          });
        }
        app.works=works;
        app.tags=tags;
        if(request_tag && request_tag.length>2){
          app.current_portfolio_tag=request_tag;


        }else {
          app.current_portfolio_tag="all_works_tag";
        }



        app.is_load=true;




      },function(){
        app.$router.push({name:'404'});
      })
    },
    methods: {
      openPortfolioTag(tag){
        var app=this;

      // app.route.params.tag=tag;
        app.current_portfolio_tag=tag;
      //return this.$router.replace({ name: "user-view", params: {service_id:this.service.last_id,tag:tag}, query: {} })
         // app.$router.push({
        //   name: 'service_page',
        //   params: { service: app.service.last_id , "tag": tag }
        // })


      },
      callModalAddProject() {
        var app=this;
        eventBus.$emit("call_modal_add_project", {'current_form_category':app.service.last_id})
        {

        }
      },




    }
  };
  </script>
